import C from './constants';
import ASYNC from './async';

const notificationEvents = [
  C.NOTIFY_PAY_INVOICE_REQUEST,
  C.NOTIFY_PAY_INVOICE_SUCCESS,
  C.NOTIFY_PAY_INVOICE_ERROR,
  C.NOTIFY_ADD_NEW_CARD_SUCCESS,
  C.NOTIFY_ADD_NEW_CARD_FAILURE,
  C.NOTIFY_ADD_NEW_DIRECT_SUCCESS,
  C.NOTIFY_ADD_NEW_DIRECT_FAILURE,
  C.TOGGLE_DEFAULT_PAYMENT_SUCCESS,
  C.TOGGLE_DEFAULT_PAYMENT_FAILURE,
  C.NOTIFY_DELETE_PAYMENT_METHOD_SUCCESS,
  C.NOTIFY_IMAGE_UPLOAD_ERROR,
  C.NOTIFY_IMAGE_UPLOAD_SUCCESS,
  C.NOTIFY_DELETE_PAYMENT_METHOD_FAILURE,
  C.USER_PERMISSIONS,
  C.ORDER_CREATION_FAILURE,
  C.UPDATE_CART_SUCCESS_NOTIFICATION,
  C.UPDATE_CART_FAILURE_NOTIFICATION,
  C.CLEAR_CART_SUCCESS_NOTIFICATION,
  C.CLEAR_CART_FAILURE_NOTIFICATION,
  C.MOV_CART_ERROR,
  C.CART_APPROVAL_SUCCESS,
  C.CART_APPROVAL_ERROR,
  C.CART_REMINDER_ERROR,
  C.CART_REMINDER_SUCCESS,
  C.CART_FETCH_FAILURE,
  C.CREATE_ORDER_SUCCESS,
  C.CREATE_ORDER_FAILURE,
  C.NOTIFY_UPDATE_ORDER_SUCCESS,
  C.NOTIFY_UPDATE_ORDER_ERROR,
  C.CREATE_PURCHASER_SCHEDULE_ORDER_SUCCESS,
  C.CREATE_PURCHASER_SCHEDULE_ORDER_FAILURE,

  // Note the _SUCCESS / _ERROR suffixes...
  ASYNC.NOTIFY_UPDATE_RETAILER_DETAILS_SUCCESS,
  ASYNC.NOTIFY_UPDATE_RETAILER_DETAILS_ERROR,
  ASYNC.NOTIFY_UPDATE_RETAILER_DATA_ATTRIBUTES_SUCCESS,
  ASYNC.NOTIFY_UPDATE_RETAILER_DATA_ATTRIBUTES_ERROR,

  C.CREATE_FAVOURITE_SUCCESS,
  C.CREATE_FAVOURITE_FAILURE,
  C.UPDATE_FAVOURITE_SUCCESS,
  C.UPDATE_FAVOURITE_FAILURE,
  C.DELETE_FAVOURITE_SUCCESS,
  C.DELETE_FAVOURITE_FAILURE,
  C.NOTIFY_WEBSOCKET_MESSAGE_SUCCESS,
  C.NOTIFY_EXPORT_SUCCESS,
  C.NOTIFY_EXPORT_ERROR,
  C.ADD_UNAVAILABLE_PRODUCT,
  C.TERMS_AND_CONDITIONS_ACCEPTANCE_FAILURE,
  C.SCHEDULED_ORDER_CANCEL_SUCCESS,
  C.SCHEDULED_ORDER_CANCEL_FAILURE,
  C.SCHEDULED_ORDER_REINSTATE_SUCCESS,
  C.SCHEDULED_ORDER_REINSTATE_FAILURE,
];

export default {
  notificationEvents,
};
